module.exports = __webpack_public_path__ + "static/media/1001116DO.f98ae39f.jpg";